import * as React from 'react';
import styled from 'styled-components';
import { Dropdown } from 'antd';
import { DropDownProps } from 'antd/lib/dropdown';
import Icon from '../Icon';

type ExtraMenuProps = DropDownProps;

const ExtraMenu: React.FC<ExtraMenuProps> = props => (
    <StyledWrapper onClick={e => e.stopPropagation()}>
      <Dropdown {...props}>
        <a>
          <Icon width={25} type="more" color="black" />
        </a>
      </Dropdown>
    </StyledWrapper>
  );

export default ExtraMenu;

const StyledWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;
